module.exports = {};



//////////////////
// WEBPACK FOOTER
// C:/Users/Home/OneDrive/Documents/hotellife_web/node_modules/core-js/modules/_iterators.js
// module id = ../../../../core-js/modules/_iterators.js
// module chunks = polyfills